import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { IReducer } from '../interface'
import MicroFrontend from '../MicroFrontend'
import { useIntl } from 'react-intl'
import SeoStore from '../components/seo/SeoStore'
import { Box } from '@mui/material'

const Store = () => {
  const { REACT_APP_STORE_HOST: storeHost } = process.env
  const isAuthenticated = useSelector((state: IReducer) => state.accountReducer.isAuthenticated)
  const userInfo = useSelector((state: IReducer) => state.accountReducer.userInfo)
  const intl = useIntl()

  useEffect(() => {
    window.addEventListener('onReadyMicrofrontendStore', sendDatas)
    return () => {
      window.removeEventListener('onReadyMicrofrontendStore', sendDatas)
    }
  }, [])

  useEffect(() => {
    sendDatas()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo])

  const sendDatas = () => {
    window.dispatchEvent(
      new CustomEvent('isAuthenticated', {
        detail: { isAuthenticated, rjo: userInfo?.rjoelegible }
      })
    )
  }

  return (
    <Box minHeight='100vh'>
      <SeoStore
        title={intl.formatMessage({ id: 'seo.store.title' })}
        description={intl.formatMessage({ id: 'seo.store.description' })}
      />
      <MicroFrontend host={storeHost} name='Store' />
    </Box>
  )
}

export default Store
